module.exports = __webpack_public_path__ + "img/pic_zb_05.a4383537.png";